import { render, staticRenderFns } from "./BindDinamoServicesTab.vue?vue&type=template&id=71237f24&"
import script from "./BindDinamoServicesTab.vue?vue&type=script&lang=js&"
export * from "./BindDinamoServicesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports